import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

// Inlines the football mark from public/icon.svg (the site's favicon/app icon) so it can be used
// as a React element, e.g. in the app bar brand button. Fixed two-tone colors, not theme-driven --
// this is the site's own mascot, not a per-team logo (see LogoProps for that separate contract).
function SiteLogo(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 64 64" {...props}>
      <g fill="#783808">
        <path d="M2.8 40.3C.7 52 3.2 57 5.1 58.9s7 4.4 18.6 2.3c-4.3-2.3-8.3-5.3-12-8.9c-3.6-3.6-6.6-7.7-8.9-12" />
        <path d="M61.1 23.8c2.1-11.6.3-17.4-1.6-19.3c-1.9-1.9-7.7-3.6-19.3-1.6c4.3 2.3 8.3 5.3 12 8.9c3.6 3.7 6.6 7.7 8.9 12" />
        <path d="M30.8 5.4c-5.6 2-11.2 5.1-15.9 9.7c-4.6 4.7-7.7 10.3-9.7 15.9c1.9 6.1 5.6 12 10.7 17.1c5.1 5.1 11 8.8 17.1 10.7c5.6-2 11.2-5.1 15.9-9.7c4.7-4.7 7.7-10.2 9.7-15.9c-1.9-6.1-5.6-12-10.7-17.1c-5-5.2-11-8.8-17.1-10.7" />
      </g>
      <g fill="#ffffff">
        <path d="M5.2 31c-1.1 3.1-1.9 6.3-2.5 9.4c2.3 4.3 5.3 8.3 8.9 12c3.6 3.6 7.7 6.6 12 8.9c3-.5 6.2-1.3 9.4-2.5c-6.1-1.9-12.1-5.6-17.1-10.7C10.8 43 7.1 37.1 5.2 31" />
        <path d="M52.2 11.8c-3.6-3.6-7.7-6.6-12-8.9c-3 .5-6.2 1.3-9.4 2.5C36.9 7.3 42.9 10.9 48 16s8.8 11 10.7 17.1c1.1-3.1 1.9-6.3 2.5-9.4c-2.4-4.2-5.4-8.2-9-11.9" />
        <path d="M37.8 19.8l6.3 6.3c1 1 2.6-.6 1.6-1.6l-6.3-6.3c-1-1-2.6.6-1.6 1.6" />
        <path d="M33.1 24.6l6.3 6.3c1 1 2.6-.6 1.6-1.6L34.7 23c-1.1-1-2.6.6-1.6 1.6" />
        <path d="M28.3 29.3l6.3 6.3c1 1 2.6-.6 1.6-1.6l-6.3-6.3c-1-1-2.6.6-1.6 1.6" />
        <path d="M23.6 34.1l6.3 6.3c1 1 2.6-.6 1.6-1.6l-6.3-6.3c-1.1-1-2.7.6-1.6 1.6" />
        <path d="M18.8 38.8l6.3 6.3c1 1 2.6-.6 1.6-1.6l-6.3-6.3c-1-1-2.6.6-1.6 1.6" />
        <path d="M21.4 44.2l23.4-23.4c1-1-.6-2.6-1.6-1.6L19.8 42.6c-1 1.1.5 2.7 1.6 1.6" />
      </g>
    </SvgIcon>
  );
}

export default SiteLogo;
